<template>
    <div>
        <span
            v-html="$t('notification.reservationDeleted',{ name: $_.get(activity,'payload.userName'), visitor:$_.get(activity,'payload.visitorName'), date: $_.get(activity, 'payload.date')})"></span>
    </div>
</template>
<script>
export default {
    name: "ReservationDeleted",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>
<style></style>
